import { render, staticRenderFns } from "./MenuComponentLink.vue?vue&type=template&id=6bab555c&scoped=true&"
import script from "./MenuComponentLink.vue?vue&type=script&lang=ts&"
export * from "./MenuComponentLink.vue?vue&type=script&lang=ts&"
import style0 from "./MenuComponentLink.vue?vue&type=style&index=0&id=6bab555c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bab555c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
